import { render } from "./TopWorkspaceMenu.vue?vue&type=template&id=2ba65964"
import script from "./TopWorkspaceMenu.vue?vue&type=script&lang=js"
export * from "./TopWorkspaceMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__